import { useEffect, useState } from "react";

import "../css/PopupSaleObservations.css";

import ButtonIconH from "../../components/ButtonIconH";
import InputTextArea from "../../components/InputTextArea";

export default ({
  show,
  obs,
  onClose,
  onSave,
  saveButtonText = "Aceptar",
  createPopupQuestion,
  removePopupQuestion,
}) => {
  const [observations, setObservations] = useState("");
  const [savedObs, setSavedObs] = useState("");

  useEffect(() => {
    if (show) {
      setObservations(obs);
      setSavedObs(obs);
      setTimeout(() => {
        document.getElementById("sale-observations-textarea")?.focus();
      }, 100);
    }
  }, [show]);

  const onSaveObservations = () => {
    onSave(observations);
    setSavedObs(observations);
    onClose();
  };

  const onCloseAttempt = () => {
    if (observations !== savedObs) {
      createPopupQuestion(
        "Existen cambios sin guardar. ¿Seguro que quiere salir?",
        () => {
          removePopupQuestion();
          onClose();
        },
        removePopupQuestion,
        "Salir",
        "Cancelar",
      );
    } else {
      onClose();
    }
  };

  return (
    show && (
      <div className="popup-container popup-normal popup-sale-observations">
        <div className="popup-message">
          <div className="popup-header">
            <div className="popup-title">Observaciones</div>
            <img
              src="/images/close-white.svg"
              loading="lazy"
              alt=""
              className="popup-close"
              onClick={onCloseAttempt}
            />
          </div>
          <div className="popup-body">
            <div className="popup-row popup-row-top">
              <InputTextArea
                id="sale-observations-textarea"
                extra="sale-observations-textarea"
                rows={12}
                maxLength={500}
                type="type-full"
                size={0}
                input={observations}
                onChange={setObservations}
              />
            </div>
          </div>
          <div className="popup-footer">
            <div className="popup-calendar-contenido-element popup-calendar-contenido-element-buttons">
              <div className="popup-row-buttons">
                <ButtonIconH
                  text={saveButtonText}
                  onClick={onSaveObservations}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  );
};
